'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box } from '../Box';
import { FooterCopyright } from './FooterCopyright';
import { FooterNav } from './FooterNav';
export const Footer = React.forwardRef(({ children, sx, copyrightYear, copyrightText, copyrightDivider, ...props }, ref) => {
    const isPadded = React.Children.count(children) > 0 && !copyrightDivider;
    return (_jsxs(Box, { component: 'footer', ref: ref, sx: {
            paddingY: isPadded ? '0.5rem' : 0,
            backgroundColor: (theme) => theme.tokens.FuelColorGray200,
            overflow: 'hidden',
            gridArea: 'footer',
            ...sx
        }, ...props, children: [React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                    if (child.type === FooterNav && !copyrightDivider) {
                        return React.cloneElement(child, {
                            sx: {
                                paddingBottom: 0
                            }
                        });
                    }
                }
                return child;
            }), _jsx(FooterCopyright, { divider: copyrightDivider, text: copyrightText, year: copyrightYear })] }));
});
Footer.displayName = 'Footer';
